import { Box, Stack, styled } from '@mui/material';
import Typography from '@/components/Typography';

export const ImageBox = styled(Box)(({ theme }) => ({
  backgroundColor: 'white',
  borderRadius: '50%',
  boxShadow: theme.shadows[15],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '38px',
  height: '38px',
  cursor: 'pointer',
  outline: 'none',
  '&:hover': {
    backgroundColor: theme.palette.secondary.A100
  },
  '&:hover svg': {
    color: theme.palette.primary.main
  },
  '&:focus-visible': { outline: 'none' },
  '& img': {
    [`${theme.breakpoints.down('sm')}`]: {
      backgroundColor: theme.palette.secondary.main
    }
  }
}));

export const ImageBoxApp = styled(Box)(({ theme }) => ({
  backgroundColor: 'white',
  borderRadius: '50%',
  boxShadow: theme.shadows[15],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '50px',
  height: '50px',
  cursor: 'pointer',
  outline: 'none',
  '&:hover': {
    backgroundColor: theme.palette.secondary.A100
  },
  '&:hover svg': {
    color: theme.palette.primary.main
  },
  '&:focus-visible': { outline: 'none' },
  '& img': {
    [`${theme.breakpoints.down('sm')}`]: {
      backgroundColor: theme.palette.secondary.main
    }
  }
}));

export const ImageBox2 = styled(Box)(({ theme }) => ({
  borderRadius: '12px',
  p: theme.spacing(1),
  boxShadow: theme.shadows[15],
  width: '130px',
  height: '130px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [`${theme.breakpoints.down('sm')}`]: {
    width: '151px',
    height: '151px'
  }
}));
export const Contact = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '0.5rem',
  alignItems: 'center'
}));
export const IntroFooter = styled(Box)(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'row',
    gap: '1rem',
    width: '93%',
    [`${theme.breakpoints.down('sm')}`]: {
      margin: '0px',
      width: '100%',
      textAlign: 'center'
    },
    alignItems: 'center',
    '& img': {
      [`${theme.breakpoints.down('sm')}`]: {
        display: 'none'
      }
    },
    '& div': {
      [`${theme.breakpoints.down('sm')}`]: {
        width: '100%'
      }
    }
  };
});
export const BoldText = styled(Box)(({ theme }) => ({
  '&.test': {
    fontWeight: 'bold',
    fontSize: '16px',
    marginRight: 4,
    [`${theme.breakpoints.down('sm')}`]: {
      marginRight: 0,
      marginBottom: 6,
      display: 'block',
      color: '#222531'
    }
  }
}));
export const Social = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '1rem',
  justifyContent: 'end',
  [`${theme.breakpoints.down('sm')}`]: {
    justifyContent: 'center',
    margin: theme.spacing(5)
  }
}));
export const AppBox = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: 32,
  alignItems: 'center',
  [`${theme.breakpoints.down('sm')}`]: {
    flexDirection: 'column',
    margin: 'auto'
  }
}));

export const Scan = styled(Typography)(({ theme }) => ({
  color: theme.palette.textColor.A80,
  fontSize: '20px',
  fontWeight: '600',
  [`${theme.breakpoints.down('sm')}`]: {
    display: 'none'
  }
}));
export const Scan2 = styled(Typography)(({ theme }) => ({
  color: theme.palette.textColor.A80,
  fontSize: '14px',
  fontWeight: '600',
  display: 'none',
  [`${theme.breakpoints.down('sm')}`]: {
    display: 'block',
    margin: 'auto'
  }
}));

export const CompanyBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'end',
  gap: '10px',
  [`${theme.breakpoints.down('sm')}`]: {
    justifyContent: 'center',
    marginTop: '26px'
  },
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center'
  }
}));

export const CopyRight = styled(Box)(({ theme }) => ({
  fontSize: '12px',
  lineHeight: '20px',
  [`${theme.breakpoints.down('sm')}`]: {
    textAlign: 'center',
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    marginTop: theme.spacing(7),
    [`${theme.breakpoints.down('sm')}`]: {
      marginTop: theme.spacing(0.25)
    }
  }
}));
